import React from "react";
import { Copy, Repeat, Volume2Icon, ThumbsUp, ThumbsDown } from "lucide-react";
import { RotatingLines } from "react-loader-spinner";
import { TypeWriterText } from "~/components";
import classNames from "classnames/bind";
import styles from "../../AIChatbot.module.scss";

const cx = classNames.bind(styles);

export default function ChatMessage({
  message,
  index,
  activeMessageId,
  speakingMessageIndex,
  onMouseEnter,
  onMouseLeave,
  onClick,
  onCopyMessage,
  onRepeatMessage,
  onChatButton,
  onTextToSpeech,
  onTypingComplete,
}) {
  if (message.ChatTypeId === 1) {
    return (
      <div
        className="d-flex chat-message flex-column align-items-end pb-4"
        onMouseEnter={() => onMouseEnter(index)}
        onMouseLeave={() => onMouseLeave(index)}
        onClick={() => onClick(index)}
      >
        <div className={cx("right-message", "chat-message-content", "fs-8-1", "border")}>
          {message.ChatContent}
        </div>

        {activeMessageId === index && (
          <div className="cursor-pointer my-1">
            <Copy size={14} className="me-3" onClick={() => onCopyMessage(message.ChatContent)} />
            <Repeat size={14} className="me-3" onClick={() => onRepeatMessage(message.ChatContent)} />
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="d-flex chat-message pb-4 flex-column"
      onMouseEnter={() => onMouseEnter(index)}
      onMouseLeave={() => onMouseLeave(index)}
      onClick={() => onClick(index)}
    >
      <div className={cx("chat-message-content", "fs-8-1")}>
        {message.IsNew ? (
          <TypeWriterText text={message.ChatContent} onComplete={() => onTypingComplete(index)} />
        ) : (
          message.ChatContent
        )}
      </div>

      {message.ShowButtons && message.ChatButtons && (
        <div className={cx("chat-buttons", "d-flex mt-2 mb-2")}>
          {message.ChatButtons.map((button, idx) => (
            <div
              key={idx}
              title={button.Text}
              className={cx("chat-button", "fs-8-1 border", "cursor-pointer")}
              onClick={() => onChatButton(button.Value, button.Text)}
            >
              <span className={cx("button-text", "fs-9", "fw-bold")}>{button.Text}</span>
            </div>
          ))}
        </div>
      )}

      {activeMessageId === index && (
        <div className="cursor-pointer my-1 d-flex">
          <Copy size={14} className="me-3" onClick={() => onCopyMessage(message.ChatContent)} />

          {speakingMessageIndex === index ? (
            <RotatingLines
              height="16"
              width="16"
              color="grey"
              wrapperClass="me-3"
              strokeWidth="4"
            />
          ) : (
            <Volume2Icon
              size={14}
              className="me-3"
              onClick={() => onTextToSpeech(message.ChatContent, index)}
            />
          )}

          <ThumbsUp size={14} className="me-3" />
          <ThumbsDown size={14} className="me-3" />
        </div>
      )}
    </div>
  );
}

